<template>
    <div>
        <div class="container my-4">
            <div class="row">
                <div class="col-lg-12 mb-4">
                    <div class="d-flex align-items-center justify-content-between mb-4">
                        <button class="btn me-md-2 btn-zebra" @click.prevent="volver()">Volver</button>
                        <h1 class="text-center flex-grow-1 font-weight-bold m-0">Planes Disponibles</h1>
                    </div>

                    <div style="margin-bottom: 1rem">
                        <DetalleCompra :cotizar="cotizar" ></DetalleCompra>
                    </div>

                    <div v-if="isLoading" class="text-center my-5">
                         <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando planes...</span>
                         </div>
                         <p class="mt-2">Buscando los mejores planes para ti...</p>
                    </div>
                    <div v-else-if="!isLoading && plans.length === 0" class="alert alert-warning text-center" role="alert">
                         No se encontraron planes que coincidan con todos los criterios (destino, fechas, edades, precios). Intenta modificar tu búsqueda.
                    </div>
                    <div v-else class="row">
                         <!-- Excluir categoría con ID "4" del filtrado -->
                         <div v-for="plan in visiblePlans" :key="plan.id" class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex"> 
                            <div class="card h-100 d-flex flex-column w-100"> 
                                <div class="card-header bg-zebra text-center"> 
                                    <h5 class="card-title text-white mb-0 fw-bold">{{ plan.description }}</h5> 
                                </div>
                                <div class="card-body flex-grow-1 d-flex flex-column"> 
                                    <div class="text-center mb-3">
                                        <div v-if="shouldShowDiscount(plan)" class="mb-1">
                                            <span class="text-danger text-decoration-line-through me-2">
                                                {{ convertCurrency(plan.pvpOriginal, 'COP', false) }}
                                            </span>
                                            <span class="badge bg-danger">Antes</span>
                                        </div>
                                        
                                        <h4 class="fw-bold zebra-txt mb-1">
                                            <span v-if="plan.pvp !== undefined">
                                                {{ convertCurrency(plan.pvp, 'COP', false) }}
                                            </span>
                                            <span v-else>Calculando...</span>
                                        </h4>
                                        <p class="text-muted small mb-3">Valor Total</p>
                                        <div v-if="shouldShowIndividualPrice(plan)" class="text-muted small" style="margin-top: -0.75rem;">
                                            {{ convertCurrency(plan.pvp / cotizar.pasajeros.length, 'COP', false) }} por pasajero
                                        </div>
                                    </div>
                                    <ul class="list-unstyled mb-4 small flex-grow-1">
                                         <template v-if="plan.benefits && plan.benefits.length > 0">
                                            <li class="mb-2 d-flex align-items-start" v-for="ben in plan.benefits" :key="ben.idBenefit">
                                                <i class="fas fa-check text-success me-2 pt-1"></i>
                                                <span class="flex-grow-1">{{ ben.text }} <span v-if="ben.idBenefit == '5'"></span><strong class="text-nowrap">{{ ben.coverage }}</strong></span>
                                            </li>
                                        </template>
                                        <li v-else class="text-muted">
                                            <i class="fas fa-spinner fa-spin me-2"></i> Cargando beneficios...
                                        </li>
                                    </ul>

                                    <div class="d-grid gap-2 mt-auto"> 
                                        <button class="btn btn-zebra" @click.prevent="verDatosPasajeros(plan.id)" :disabled="plan.pvp === undefined"> 
                                            Comprar Ahora
                                        </button>
                                        <button class="btn btn-sm btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#detallePlan" @click.prevent="getBenefits(plan.id)">
                                            Ver todas las coberturas
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="detallePlan" tabindex="-1" aria-labelledby="detallePlanLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable"> 
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="detallePlanLabel">Detalle de Coberturas</h1> 
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!benefits || benefits.length === 0" class="text-center">Cargando detalles...</div>
                        <table v-else class="table table-striped table-hover"> 
                            <thead>
                                <tr>
                                    <th style="width: 60%;">Beneficio</th> <th style="width: 40%;">Cobertura</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ben in benefits" :key="ben.idBenefit">
                                    <td>{{ ben.benefit }}</td>
                                    <td>{{ ben.coverage }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DetalleCompra from '@/components/components/DetalleCompra';
import axios from 'axios';
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Planes',
    data() {
        return {
            isLoading: true,
            cotizar: {},
            plans: [],
            visiblePlans: [],
            benefits: [],
            trm: 0,
            currency: 'USD',
            apiOptions: {
                headers: {
                    language: 'spa',
                    token: '',
                    'Content-Type': 'application/json'
                }
            }
        };
    },
    mounted() {
        try {
            const storedCotizar = localStorage.getItem('cotizar');
            if (storedCotizar) {
                this.cotizar = JSON.parse(storedCotizar);
                if (!Array.isArray(this.cotizar.pasajeros)) {
                    this.cotizar.pasajeros = [];
                    console.warn("Pasajeros en localStorage no era un array, se reseteó.");
                }
            } else {
                console.error("No se encontró información de cotización en localStorage.");
                this.isLoading = false;
                return;
            }
        } catch (e) {
            console.error("Error al parsear cotizar desde localStorage:", e);
            this.isLoading = false;
            return;
        }

        this.getTRM().then(() => {
            this.loadData();
        }).catch(error => {
            console.error("Error al obtener TRM:", error);
            this.isLoading = false;
        });
    },
    methods: { 
        async loadData() {
            this.isLoading = true;
            try {
                await this.getTRM();
                await this.getPlanes();
            } catch (error) {
                console.error("Error al cargar datos:", error);
                this.plans = [];
            }
            this.filterPlans();
            this.isLoading = false;
        },
        filterPlans() {
            // Filtrar planes para excluir el plan con ID "0"
            this.visiblePlans = this.plans.filter(plan => plan.idCategory !== "0");
        },
        async getPlanes() {
            if (!this.cotizar || !this.cotizar.destino || this.cotizar.pasajeros.length === 0) {
                console.error("Datos de cotización incompletos para buscar planes.");
                this.plans = [];
                return;
            }
            try {
                const params = { "paginate": false };
                const response = await this.$root.post('plans/list', params);
                if (!response || !response.data || !response.data.data) {
                    console.error("Respuesta inválida de API plans/list");
                    this.plans = [];
                    return;
                }
                const allPlansApi = response.data.data;
                const filteredPlans = allPlansApi.filter(plan => {
                    const { destino, noDias, pasajeros, idCategoria } = this.cotizar;                    
                    if (!plan.restrictions || !plan.minDays || !plan.maxDays || !plan.minAge || !plan.maxAge) {
                        return false;
                    }
                    const { availableTerritory } = plan.restrictions;
                    const { minDays, maxDays, minAge, maxAge, idCategory } = plan;
                    if (availableTerritory !== destino) return false;
                    const categoriaValida = (idCategory == idCategoria);
                    if (!categoriaValida) return false;
                    const diasValidos = (parseInt(minDays) <= noDias && parseInt(maxDays) >= noDias);
                    if (!diasValidos) return false;
                    const numPasajeros = pasajeros.length;
                    const numPasajerosValido = numPasajeros >= parseInt(plan.minNumPass) && numPasajeros <= parseInt(plan.maxNumPass);
                    if (!numPasajerosValido) return false;
                    const isFamilyPlan = plan.familyPlan === 'Y';
                    const isCouplePlan = plan.couplePlan === 'Y';
                    
                    if (isCouplePlan && numPasajeros === 2) {
                        const edadValidaCouple = pasajeros.every(p => parseInt(p.edad) < 75);
                        return edadValidaCouple;
                    }
                    
                    if (isFamilyPlan) {
                        const adultos = pasajeros.filter(p => parseInt(p.edad) >= 22 && parseInt(p.edad) < 75);
                        const menores = pasajeros.filter(p => parseInt(p.edad) < 22);

                        const adultosValidos = adultos.length === 2;
                        const menoresValidos = menores.length > 0 && menores.length <= 3;
                        
                        if (adultosValidos && menoresValidos) {
                            return true;
                        }
                    }
                    const edadesValidasIndividual = pasajeros.every(pasajero => {
                        const edad = parseInt(pasajero.edad);
                        return !isNaN(edad) && edad >= parseInt(minAge) && edad <= parseInt(maxAge);
                    });
                    return edadesValidasIndividual;
                });

                const planPromises = filteredPlans.map(async (plan) => {
                    try {
                        const priceData = await this.loadPlanPrice(plan.id);
                        const benefitsData = await this.getBenefitsPlan(plan.id);
                        if (plan.description == '' || !plan.description){
                            plan.description = plan.plan;
                        }
                        return {
                            ...plan,
                            pvp: priceData.pvp,
                            pvpOriginal: priceData.pvpOriginal,
                            basePrices: priceData.basePrices,
                            unit: priceData.unit,
                            benefits: benefitsData
                        };
                    } catch (error) {
                        return null;
                    }
                });

                const results = await Promise.all(planPromises);
                this.plans = results.filter(plan => plan !== null);
                this.enviarCorreoConPlanes();
            } catch (error) {
                console.error('Error general en getPlanes:', error);
                this.plans = [];
            }
        },
        async getTRM() {
            if (typeof this.$root.getTRM !== 'function') {
                console.warn("this.$root.getTRM no es una función. Usando TRM = 1.");
                this.trm = 1;
                return Promise.resolve();
            }
            try {
                const res = await this.$root.getTRM();
                if (res && res.data) {
                    this.trm = res.data;
                    localStorage.setItem("trm", this.trm);
                } else {
                    console.warn("Respuesta inválida de TRM API o TRM no es un número positivo. Usando TRM = 1.", res);
                    this.trm = 1;
                }
            } catch (error) {
                console.error("Error en la llamada a getTRM:", error);
                this.trm = 1;
                throw error;
            }
        },
        // En el método calculatePrice
        calculatePrice(plan, includeNoDias = true) {
            if (!plan || plan.pvp === undefined) return 0;
            
            // Asegurarse de que el pvp sea un número antes de usarlo
            const pvpValue = parseFloat(plan.pvp);
            if (isNaN(pvpValue)) {
                return 0; // Retorna 0 si no es un número válido
            }
            
            if (plan.unit === "bloques" || !includeNoDias) {
                return pvpValue;
            }
            return pvpValue * this.cotizar.noDias;
        },
        // Método actualizado para usar calculatePrice
        convertCurrency(value, targetCurrency, includeLabel = true) {
            let formattedValue;
            let label = '';
            const trm = parseFloat(this.trm);

            // Si se pasa un objeto plan completo en lugar de un valor
            if (typeof value === 'object' && value !== null && value.pvp !== undefined) {
                const basePrice = this.calculatePrice(value);
                
                if (targetCurrency === 'COP') {
                    if (trm > 0) {
                        formattedValue = basePrice * trm;
                        label = includeLabel ? ' COP' : '';
                        try {
                            return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(formattedValue) + label;
                        } catch (e) {
                            console.error("Error formateando a COP:", e);
                            return `${formattedValue.toFixed(0)}${label}`;
                        }
                    } else {
                        targetCurrency = 'USD';
                        console.warn("Intentando convertir a COP sin TRM válida. Mostrando en USD.");
                    }
                }

                formattedValue = basePrice;
                label = includeLabel ? ' USD' : '';
                try {
                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(formattedValue) + label;
                } catch (e) {
                    console.error("Error formateando a USD:", e);
                    return `${formattedValue.toFixed(2)}${label}`;
                }
            }
            
            // Si se pasa un valor numérico directo (comportamiento anterior)
            if (targetCurrency === 'COP') {
                if (trm > 0) {
                    formattedValue = value * this.trm;
                    label = includeLabel ? ' COP' : '';
                    try {
                        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(formattedValue) + label;
                    } catch (e) {
                        console.error("Error formateando a COP:", e);
                        return `${formattedValue.toFixed(0)}${label}`;
                    }
                } else {
                    targetCurrency = 'USD';
                    console.warn("Intentando convertir a COP sin TRM válida. Mostrando en USD.");
                }
            }

            formattedValue = value;
            label = includeLabel ? ' USD' : '';
            try {
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(formattedValue) + label;
            } catch (e) {
                console.error("Error formateando a USD:", e);
                return `${formattedValue.toFixed(2)}${label}`;
            }
        },
        toggleCurrency() {
            this.currency = this.currency === 'USD' ? 'COP' : 'USD';
        },
        async loadPlanPrice(planId) {
            const { cotizar } = this;
            if (!cotizar || !cotizar.pasajeros || cotizar.pasajeros.length === 0) {
                throw new Error(`Datos de pasajeros inválidos para calcular precio del plan ${planId}`);
            }
            const edades = cotizar.pasajeros.map(item => parseInt(item.edad)).filter(e => !isNaN(e));
            if (edades.length === 0) {
                throw new Error(`No hay edades válidas para calcular precio del plan ${planId}`);
            }
            const edadMinima = Math.min(...edades);
            const edadMaxima = Math.max(...edades);
            const numPasajeros = cotizar.pasajeros.length;
            try {
                const res = await this.$root.get(`plans/plan/${planId}`);
                if (!res || !res.data) {
                    throw new Error(`Respuesta inválida de API para plan ${planId}`);
                }
                const plan = res.data;
                const validaciones = {
                    dias: cotizar.noDias >= plan.minDays && cotizar.noDias <= plan.maxDays,
                    edad: edadMinima >= plan.minAge && edadMaxima <= plan.maxAge,
                    pasajeros: numPasajeros >= plan.minNumPass && numPasajeros <= plan.maxNumPass
                };
                if (!validaciones.dias) {
                    throw new Error(`Número de días (${cotizar.noDias}) fuera del rango permitido: ${plan.minDays}-${plan.maxDays} días`);
                }
                if (!validaciones.edad) {
                    throw new Error(`Rango de edades (${edadMinima}-${edadMaxima}) fuera del permitido: ${plan.minAge}-${plan.maxAge} años`);
                }
                if (!validaciones.pasajeros) {
                    throw new Error(`Número de pasajeros (${numPasajeros}) fuera del rango permitido: ${plan.minNumPass}-${plan.maxNumPass} pasajeros`);
                }
                const basePricesRes = await this.$root.get(`plans/premiums/${planId}`);
                if (!basePricesRes || !basePricesRes.data) {
                    throw new Error(`Respuesta inválida de premiums API para plan ${planId}`);
                }
                const pricesData = basePricesRes.data;
                let basePrices = [];
                if (pricesData.basePrices && Array.isArray(pricesData.basePrices)) {
                    basePrices = pricesData.basePrices;
                } else if (Array.isArray(pricesData)) {
                    basePrices = pricesData;
                } else {
                    throw new Error(`Estructura de precios no reconocida para plan ${planId}`);
                }
                const applicablePrices = basePrices.filter(price => {
                    const priceNumDays = parseInt(price.numDays);
                    const diasValidos = cotizar.noDias <= priceNumDays;
                    const esAdicional = price.additional === "N";
                    return diasValidos && esAdicional;
                });
                if (applicablePrices.length === 0) {
                    throw new Error(`No se encontraron precios aplicables para las condiciones: ${cotizar.noDias} días, edades ${edadMinima}-${edadMaxima}`);
                }
                let selectedPrice;
                if (applicablePrices.length === 1) {
                    selectedPrice = applicablePrices[0];
                } else {
                    const sortedPrices = applicablePrices.sort((a, b) => {
                        const daysDiff = parseInt(a.numDays) - parseInt(b.numDays);
                        if (daysDiff !== 0) return daysDiff;
                        return parseFloat(a.pvp) - parseFloat(b.pvp);
                    });
                    selectedPrice = sortedPrices[0];
                }
                let pvpBase = parseFloat(selectedPrice.pvp);
                let precioTotal = 0;
                let precioOriginal = 0;
                const isFamilyPlan = plan.familyPlan === 'Y';
                const isCouplePlan = plan.couplePlan === 'Y';
                const precioPorPasajeroBase = this.calculatePrice({ pvp: pvpBase, unit: selectedPrice.unit });
                const pasajerosOverage = cotizar.pasajeros.filter(p => parseInt(p.edad) >= parseInt(plan.overage));
                const pasajerosStandard = cotizar.pasajeros.filter(p => parseInt(p.edad) < parseInt(plan.overage));
                // eslint-disable-next-line no-unused-vars
                const costoOverage = pasajerosOverage.reduce((acc, p) => acc + (precioPorPasajeroBase * parseFloat(plan.overageFactor)), 0);
                const costoOriginalStandard = pasajerosStandard.length * precioPorPasajeroBase;
                precioOriginal = costoOverage + costoOriginalStandard;
                let costoTotalStandard = 0;
                const adultos = pasajerosStandard.filter(p => parseInt(p.edad) >= 22);
                const menores = pasajerosStandard.filter(p => parseInt(p.edad) < 22);
                if (isCouplePlan && numPasajeros === 2 && pasajerosOverage.length === 0) {
                    costoTotalStandard = precioPorPasajeroBase * parseFloat(plan.coupleFactor);
                } else if (isFamilyPlan && adultos.length === 2 && menores.length > 0 && menores.length <= parseInt(plan.familyMaxNumMinors) && pasajerosOverage.length === 0) {
                    costoTotalStandard = precioPorPasajeroBase * parseFloat(plan.familyFactor);
                } else {
                    costoTotalStandard = costoOriginalStandard;
                }
                precioTotal = costoOverage + costoTotalStandard;
                console.log(`Plan ${planId} - Precio seleccionado:`, {
                    pvp: precioTotal,
                    pvpOriginal: precioOriginal,
                    unit: selectedPrice.unit,
                    numDays: selectedPrice.numDays,
                    cotizacion: `${cotizar.noDias} días, edades ${edadMinima}-${edadMaxima}`
                });
                return {
                    pvp: precioTotal,
                    pvpOriginal: precioOriginal,
                    basePrices: selectedPrice,
                    unit: selectedPrice.unit,
                    planData: plan
                };
            } catch (error) {
                console.error(`Error al cargar precio para plan ${planId}:`, error);
                throw error;
            }
        },
        volver() {
            this.$router.push('/') 
        },
        async datosComprador() {
        },
        async getBenefits(idPlan) {
            this.benefits = [];
            try {
                const response = await this.$root.get(`plans/benefits/${idPlan}`);
                if (response && response.data) {
                    this.benefits = response.data;
                } else {
                    console.warn(`Respuesta inválida al obtener beneficios completos para plan ${idPlan}`);
                }
            } catch (error) {
                console.error(`Error al obtener los beneficios para el modal (Plan ID ${idPlan}):`, error);
                this.benefits = [{ benefit: 'Error al cargar beneficios', coverage: '-' }];
            }
        },
        async getBenefitsPlan(idPlan) {
            const allowedBenefits = [
                '40', // Asistencia médica por accidente
                '41', // Asistencia médica por enfermedad no preexistente (Incluye COVID - 19)
                '42', // Asistencia m&eacute;dica por enfermedad preexistente
                '5', // Repatriaci&oacute;n funeraria
                '3' // Traslado y/o repatriación médica
            ];
            try {
                const response = await this.$root.get(`plans/benefits/${idPlan}`);
                if (!response || !response.data || !Array.isArray(response.data)) {
                    console.warn(`Respuesta inválida al obtener beneficios para tarjeta (Plan ID ${idPlan})`);
                    return [];
                }

                return response.data
                    .filter(a => allowedBenefits.includes(a.idBenefit))
                    .map(a => {
                        let text = '';
                        if (a.idBenefit == "5") {
                            text = 'Repatriación funeraria';
                        } else if (a.idBenefit == '42') {
                            text = 'Asistencia médica por enfermedad preexistente';
                        } else {
                            text = a.benefit;
                        }
                        return { ...a, text };
                    });
            } catch (error) {
                console.error(`Error al obtener/filtrar beneficios para tarjeta (Plan ID ${idPlan}):`, error);
                return [];
            }
        },
        verDatosPasajeros(planId) {
            const selectedPlan = this.plans.find(a => a.id == planId);

            if (!selectedPlan || selectedPlan.pvp === undefined) {
                console.error("No se puede continuar, el plan seleccionado no tiene precio cargado.", selectedPlan);
                alert("Error: No se pudo cargar el precio de este plan. Intente de nuevo.");
                return;
            }

            this.cotizar.plan = selectedPlan;
            this.cotizar.trm = this.trm;
            
            // Calcular precios teniendo en cuenta la unidad
            const basePrice = this.calculatePrice(selectedPlan);
            this.cotizar.plan.precioUSD = this.convertCurrency(basePrice, 'USD');
            this.cotizar.plan.precioCOP = this.convertCurrency(basePrice, 'COP');
            this.cotizar.plan.precioFinalCOP = basePrice * this.trm;

            localStorage.setItem("cotizar", JSON.stringify(this.cotizar));
            this.$router.push('/datosCompra');
        },
        enviarCorreoConPlanes() {
            const payload = {
                to: this.cotizar.correo,
                subject: 'Tu cotización de Asistencia de Viaje',
                data: {
                    ...this.cotizar,
                    trm: this.trm,
                    planes: this.plans
                }
            };

            axios.post(process.env.VUE_APP_API_URL_ZEBRA + 'enviarCot', payload, this.apiOptions)
                .then(({ data }) => {
                    console.log('Correo con planes enviado:', data);
                })
                .catch(error => {
                    console.error('Error al enviar correo con planes:', error);
                });
        },
        shouldShowDiscount(plan) {
            if (!plan.pvpOriginal || typeof plan.pvp === 'undefined') {
                return false;
            }
            // Show discount if original price is greater than current price (with a small tolerance)
            return (plan.pvpOriginal - plan.pvp) > 0.01;
        },
        shouldShowIndividualPrice(plan) {
            if (this.cotizar.pasajeros.length <= 1 || !plan.pvpOriginal || typeof plan.pvp === 'undefined') {
                return false;
            }
            // Show individual price if there is no discount and more than one passenger
            return Math.abs(plan.pvp - plan.pvpOriginal) < 0.01;
        }
    },
    components: {
        DetalleCompra
    }
};
</script>

<style scoped>
    /* Estilos específicos para esta vista */
    .card-header.bg-zebra {
        background-color: #32A5AB;
        border-bottom: none;
    }
    .zebra-txt {
      color: #32A5AB;
    }
    .card {
        box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        border: 1px solid #eee;
    }
    .card:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 10px rgba(0,0,0,0.15);
    }
    .card-footer {
        background-color: unset;
        border-top: none;
    }
</style>